import {useDevice} from 'platform/foundation';

import {prop} from 'ramda';

import type {DashboardInterestResponseBody} from '@dms/api/core';

import {DashboardTileSize} from '../../../types/DashboardTileSize';
import {DASHBOARD_TILE_NATURAL_ROWS} from '../../../utils/dashboardTileNaturalRows';
import {DASHBOARD_TILE_ROW_COLUMNS} from '../../../utils/dashboardTileRowColumns';
import {DASHBOARD_TILE_ROW_SPACING} from '../../../utils/dashboardTileRowSpacing';
import {DashboardTileRows} from '../../DashboardTileRows/DashboardTileRows';
import {LatestInterestItem} from './LatestInterestItem';

interface LatestInterestRowsProps {
  interests: DashboardInterestResponseBody[];
  size: DashboardTileSize;
  isPreview?: boolean;
  naturalRows?: number;
}

export function LatestInterestRows(props: LatestInterestRowsProps) {
  const device = useDevice();
  const effectiveSize = device === 'mobile' ? 'half' : props.size;

  return (
    <DashboardTileRows
      id="latest-interests"
      rows={props.interests}
      getRowKey={(interest) => interest.id}
      getRowLayoutKey={(interest) => JSON.stringify(interest)}
      renderRow={(interest, options) => (
        <LatestInterestItem
          interest={interest}
          isProbe={options.isProbe}
          isPreview={props.isPreview}
        />
      )}
      naturalRows={props.naturalRows ?? DASHBOARD_TILE_NATURAL_ROWS}
      spacing={DASHBOARD_TILE_ROW_SPACING}
      columns={prop(effectiveSize, DASHBOARD_TILE_ROW_COLUMNS)}
    />
  );
}
